module.exports = __webpack_public_path__ + "img/18.230611c8.png";